import { createAsyncActionType } from './index';

export const LIVE_EVENTS_GET = createAsyncActionType(
  'liveEvent',
  'LIVE_EVENTS_GET'
);

export const SESSION_USERS_GET = createAsyncActionType(
  'liveEvent',
  'SESSION_USERS_GET'
);
export const SESSION_USERS_RESET = '@@liveEvent/SESSION_USERS_RESET';

export const USERS_ATTENDANCE_SET = createAsyncActionType(
  'liveEvent',
  'USERS_ATTENDANCE_SET'
);

export const QUIZ_ATTEMPTS_SET = createAsyncActionType(
  'liveEvent',
  'QUIZ_ATTEMPTS_SET'
);

export const QUIZ_VISIBILITY_SET = createAsyncActionType(
  'liveEvent',
  'QUIZ_VISIBILITY_SET'
);

export const SESSION_RESULT_GET = createAsyncActionType(
  'liveEvent',
  'SESSION_RESULT_GET'
);

export const SESSION_RESULT_EXPORT = createAsyncActionType(
  'liveEvent',
  'SESSION_RESULT_EXPORT'
);
